jQuery(function($) {

      $('.testimonial-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 3500,
        responsive: [
          {
            breakpoint: 767,
            settings: {

            }
          }        
        ]        
      }); 

      var $personalCount = $('.slideCount.personal');
      var $businessCount = $('.slideCount.business');
      var $personalSlider = $('.services-slider.personal');
      var $businessSlider = $('.services-slider.business');
      
      $personalSlider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        var i = (currentSlide ? currentSlide : 0) + 1;
        $personalCount.html(i + '<span class="seperator"></span>' + slick.slideCount);
      });

      $businessSlider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        var i = (currentSlide ? currentSlide : 0) + 1;
        $businessCount.html(i + '<span class="seperator"></span>' + slick.slideCount);
      });      

      $(window).on('load resize', function() {
        if ($(window).width() < 768) {
            $('.services-slider').not('.slick-initialized').slick({
                centerMode: true,
                centerPadding: '20px',
                autoplay: true,
                autoplaySpeed: 3000,
                infinite: false,
                arrows: true,
                dots: false,
                swipe: true,
                draggable: true,
                prevArrow: '<button type="button" class="slick-prev"><i class="far fa-long-arrow-left"></i></button>',
                nextArrow: '<button type="button" class="slick-next"><i class="far fa-long-arrow-right"></i></button>',
            });
        } else {
            $('.services-slider').slick("destroy");
        }
    });
           
      $(".tabs").on("change.zf.tabs", function () {
        $(".slick-slider").slick("setPosition");
    });         
});